'use client'

import { useEffect } from 'react'

export function ConsentManager() {
  useEffect(() => {
    const handleAccept = () => {
      // No-op: gtag is already tracking via layout.tsx.
      // Hook preserved for future consent-mode extensions.
    }

    window.addEventListener('cookieConsentAccepted', handleAccept)
    return () => window.removeEventListener('cookieConsentAccepted', handleAccept)
  }, [])

  return null
}
